window.freeShippingValue = document.querySelector("[data-free-shipping]").getAttribute("data-free-shipping");
window.suggestedProducts = document.querySelector("[data-suggested-products]").getAttribute("data-suggested-products");
window.suggestedTitle = document.querySelector("[data-suggested-products]").getAttribute("data-suggested-title");

window.cartDrawer = function () {
  window.componentCartDrawer = new Vnda.Component.CartDrawer({
    anchor: 'right',
    disableShippingCalculation: false,
    display: 'list',
    enableSamples: true,
    freeShipping: window.freeShippingValue,
    startOpen: false,
    suggestedProductsTag: window.suggestedProducts,
    titleSuggested: window.suggestedTitle,
  });

  const root = document.getElementById('component-cart-drawer-root');
  if (!root) return;
  
  componentCartDrawer.render(root);
  var button = document.getElementById('bt-drawer');
  if (button) button.addEventListener('click', window.componentCartDrawer.toggle);

  // Altera botão "Continuar comprando" (temporário)
  let observer = new MutationObserver(mutation => { 
    console.log('mutation run');
    let button = root.querySelector('.cart-drawer-continue');
    console.log('cart button', button);
    if (button) {
      if (!button.hasAttribute('data-ready')) {
        let newButton = button.cloneNode(true);
        newButton.addEventListener('click', () => { window.location.href = '/janiero-vende-tudo' });
        newButton.setAttribute('data-ready', true);
        button.parentElement.appendChild(newButton);
        button.remove();
      }
    }
  });
  observer.observe(root, { attributes: true, childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", window.cartDrawer);
